"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Positions of scroll that can be done to bring and element in view.
 */
var ScrollInViewType;
(function (ScrollInViewType) {
    ScrollInViewType["TOP"] = "top";
    ScrollInViewType["BOTTOM"] = "bottom";
    ScrollInViewType["ANY"] = "any";
})(ScrollInViewType = exports.ScrollInViewType || (exports.ScrollInViewType = {}));
